import styled from 'styled-components';
import { breakpoint, ContentSpacing } from '@estee/elc-base-theme';

const { space12, space16 } = ContentSpacing;

export const StyledKitImage = styled.img`
    margin-inline-end: ${space12};
    width: 80px;
`;

export const StyledKitItemsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${space16};
    margin-block-end: ${space12};
    ${breakpoint('desktop')`
        grid-column: 1 / 3;
        gap: 0;
        margin-block-end: 0;
    `};
`;
